import { NavBar } from "../../components/layout/navbar/navbar";
import CapitalStyles from "./capital.module.css";
import JourneyImage from "../../assets/images/firstimage.png";
import TropicalHome from "../../assets/images/Modern-Tropical-Home.png"
import Terrace from "../../assets/images/Modern-Building.png"
import Mask from "../../assets/images/Mask-group.png"
import Tower from "../../assets/images/value_tower.png"
import Mission from "../../assets/images/logo/Mission.svg";
import Vision from "../../assets/images/logo/Vision.svg";
import Portfolio_img from "../../assets/images/portfolio-overview.png"
import Investment from "../../assets/images/investment_environment.png"
import Next_image1 from "../../assets/images/next_image1.png";
import Next_image2 from "../../assets/images/next_image2.png";
import Service_1 from "../../assets/images/service_image1.png";
import Service_2 from "../../assets/images/service_image2.png";
import Service_4 from "../../assets/images/service_image4.png";
import Partnership_image from "../../assets/images/partners_image.png";
import investment_theme from "../../assets/images/investment_theme.png"
import InvestIcon from "../../assets/images/investicon.svg";
import Home from "../../assets/images/icons/home.svg";
import People from "../../assets/images/icons/people.svg";
import Grid from "../../assets/images/icons/grid.svg";
import Arrow_up from "../../assets/images/icons/direction-up.svg";
import zee from "../../assets/images/icons/z.svg";
import Structure_img from "../../assets/images/structuring_approach.png";
import ThemeList from "../../components/themeList/themeList";
import AboutCard from "../../components/aboutCard/aboutCard";
import ServiceCard from "../../components/servicesCard/servicesCard";
import { Link, useNavigate } from "react-router-dom";
import React, { useRef, useCallback, useEffect, useState } from "react";
import { urlConfig } from "../../config/urlConfig";

const Capital = () => {
  const navigate = useNavigate();
  const sliderRef = useRef(null);
  const [videoBgUrl, setVideoBgUrl] = useState("");

  useEffect(() => {
    getBgVideo();
  }, []);

  const getBgVideo = async () => {
    try {
      const response = await fetch(
        `${urlConfig.BASE_URL}/api/platform-video?populate=*`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        console.log("An error occurred while trying to get all properties");
        return;
      }

      const data = await response.json();
      setVideoBgUrl(data.data.attributes.videoBackground.data.attributes.url);
    } catch (error) {
      console.error("Error fetching video background:", error);
    }
  };

  return (
    <>
      <header className={CapitalStyles.hero_section}>
        <NavBar />
      </header>
      <main>
        <div className={CapitalStyles.container}>
          <section className={CapitalStyles.hero_text_section}>
            <div>
              <div className={`col-lg-9  `}>
                <div className={CapitalStyles.text_container}>
                  <h3 className={CapitalStyles.title}>
                    Delivering Value in a Volatile World.
                  </h3>
                </div>
              </div>
            </div>
          </section>

          <div className={CapitalStyles.image_container}>
            <img
              src={TropicalHome}
              alt="Mosun Homes and Realtors Limited we are a team of experts"
              className={`${CapitalStyles.overlapPicture}`}
            />
          </div>
        </div>

        <section className={`${CapitalStyles.about_section}`}>
          <div className={CapitalStyles.aboutContainer}>
            <div>
              <img src={Terrace} alt="" className={CapitalStyles.top_left_image} />
            </div>
            <div className={CapitalStyles.about_text_middle}>
              <h2 className={CapitalStyles.about_text}>
                About Us
              </h2>
              <h6 className={CapitalStyles.about_details}>
                Mosun Capital is an investment and management company focused on generating compelling and sustainable investor returns through the acquisition, development and management of assets and businesses in key economic anchors across in Nigeria.
                <div><br /></div>
                Our Real Estate and Infrastructure business seeks to opportunistically invest in prime locations to take advantage of market dislocation, information asymmetry,
                under-managed and under-capitalised opportunities in the retail, industrial and mixed-use sub-sectors.
              </h6>
            </div>
            <div>
              <img src={Mask} alt="" className={CapitalStyles.top_right_image} />
            </div>
          </div>
          <div className={CapitalStyles.aboutCard}>
            <AboutCard heading={"Mission"} text={"Our mission is to forge strategic relationships with capital partners and invest in high-value projects, driving growth and delivering exceptional returns for our partners."} right={false} logo={<img src={Mission} alt="mission" style={{ width: "2.1rem", height: "2.1rem" }} />} />
            <AboutCard heading={"Vision"} text={"Our vision is to become a leading asset manager and financial services provider with an established and valuable presence in the Nigerian financial market."} right={true} logo={<img src={Vision} alt="vision" style={{ width: "2.1rem", height: "2.1rem" }} />} />
          </div>
        </section>

        <section className={CapitalStyles.value_container}>
          <div className={CapitalStyles.decorative_element}></div>
          <div className={CapitalStyles.value_text}>
            <h2 className={CapitalStyles.value_text_header}>Value Creation Strategies</h2>
            <h6 className={CapitalStyles.value_text_content}>Our core strategies focus on Private Equity & Credit to drive capital and growth in our businesses. <br></br>
            <br></br>Our opportunistic business seeks to acquire and develop well-located assets across prime locations in Nigeria.<br></br>
            <br></br>In connection with these acquisitions and developments, we build businesses and partner with value chain players to manage the underlying assets and ultimately maximize their value by instituting best-in-class management.<br></br>
            <br></br>Post acquisition and development, we also invest in the assets to create value before exiting and returning capital to our partners</h6>
          </div>
          <div className={CapitalStyles.value_image_container}>
            <img src={Tower} className={CapitalStyles.value_image} alt="Modern real estate development" />
          </div>
        </section>

        <section className={CapitalStyles.invest_section}>
          <div className={CapitalStyles.header_section}>
            <h2 className={`${CapitalStyles.title3}`}>
              Investment Environment
            </h2>
            <p className={CapitalStyles.details3}>
              We believe the current headwinds facing the Nigerian economy are creating a prime environment for opportunistic investing.
            </p>
            <div className={CapitalStyles.invest_list}>
              <div className={CapitalStyles.invest_item}>
                <img src={InvestIcon} alt="Experienced Icon" className={`${CapitalStyles.icon} img-fluid`} />
                <div className={CapitalStyles.invest_container}>
                  <p className={CapitalStyles.invest_text}>Opportunistic capital historically perform well after an economic downturn</p>
                </div>
              </div>
              <div className={CapitalStyles.invest_item}>
                <img src={InvestIcon} alt="Expertise Icon" className={`${CapitalStyles.icon} img-fluid`} />
                <div className={CapitalStyles.invest_container}>
                  <p className={CapitalStyles.invest_text}>Potential for strong revenue growth</p>
                </div>
              </div>
              <div className={CapitalStyles.invest_item}>
                <img src={InvestIcon} alt="Transparency Icon" className={`${CapitalStyles.icon} img-fluid`} />
                <div className={CapitalStyles.invest_container}>
                  <p className={CapitalStyles.invest_text}>Limited new supply</p>
                </div>
              </div>
            </div>
          </div>
          <div className={`col-lg-12 ${CapitalStyles.investimage}`}>
            <img src={Investment} alt="investment 1" className={`${CapitalStyles.invest1} img-fluid`} />
          </div>
        </section>

        <section className={CapitalStyles.services_section}>
          <div className={CapitalStyles.service_heading_container}>
          <h2 className={`${CapitalStyles.title3}`}>Our Services</h2>
          <p className={CapitalStyles.details3}>As General Partners (GP) we leverage our industry knowledge, experience, and insights to aid in the formulation and execution of our investment strategies</p>
          </div>
          <div className={CapitalStyles.service_card_container}>
            <ServiceCard
              title={"1- Deal Structuring"}
              text={
                "We formulate and navigate complex deal structures, including but not limited to joint ventures and private capital. Our strategic approach aims to maximise value, mitigate risk, and ensure an optimal outcome for our partners."
              }
              customColor={"#E99B24"}
              image={<img src={Service_1} style={{ width: "100%" }} alt="service_image1" />}
            />
            <ServiceCard
              title={"2- Strategic Capital Allocation and Portfolio Planning"}
              text={
                "We offer strategic guidance to our partners to enhance the optimisation of capital. Our comprehensive approach to portfolio strategy encompasses services like prioritisation frameworks, analysis of funding and financing options, and consideration of tax implications. These aids informed capital decisions and effectively managing portfolios throughout the entire cycle, including acquisition, operational management, reinvestment, and divestment."
              }
              customColor={"#8D3C25"}
              image={<img src={Service_2} style={{ width: "100%" }} alt="service_image2" />}
            />
            <ServiceCard
              title={"3- Real Estate Investment Advisory"}
              text={
                "We formulate comprehensive investment strategies, encompassing feasibility assessments backed by robust financial modelling and conducting risk analysis."
              }
              customColor={"#361800"}
              image={<img src={Service_4} style={{ width: "100%" }} alt="service_image4" />}
            />
          </div>
        </section>

        <section className={CapitalStyles.investment_container}>
        <h2 className={`${CapitalStyles.title3}`}>Investment Themes</h2>
          <div className={CapitalStyles.investment_theme}>
            <div className={CapitalStyles.investment_list_container}>
              <ThemeList title={"Demographics & Affordability"} logo={<img src={Home} style={{ width: "1.2rem", height: "1.2rem" }} alt="home" />} />
              <ThemeList title={"The New Normal"} logo={<img src={People} alt="people" style={{ width: "1.2rem", height: "1.2rem" }} />} />
              <ThemeList title={"Last Mile Distribution"} logo={<img src={Grid} alt="grid" style={{ width: "1.2rem", height: "1.2rem" }} />} />
              <ThemeList title={"Infrastructure Upgrades"} logo={<img src={Arrow_up} alt="arrow up" style={{ width: "1.2rem", height: "1.2rem" }} />} />
              <ThemeList title={"Data & Inventory Security"} logo={<img src={zee} alt="z icon" style={{ width: "1.2rem", height: "1.2rem" }} />} />
            </div>
            <div className={CapitalStyles.investment_image_container}>
              <img src={investment_theme} alt="investment_theme" className={CapitalStyles.investment_theme_image} />
            </div>
          </div>
        </section>

        <section className={CapitalStyles.portfolioSection}>
          <div className={CapitalStyles.container_portfolio}>
            <div className={CapitalStyles.content}>
              <div className={CapitalStyles.textContent}>
                <h2 className={CapitalStyles.title}>Current Portfolio Overview</h2>

                <div className={CapitalStyles.subtitle}>
                  <strong>Fast-Growing Alternative Asset Manager</strong>
                </div>

                <p className={CapitalStyles.description}>
                  We are asset owners with adequate operating experience that seek to develop and acquire attractive assets and businesses.
                </p>

                <div className={CapitalStyles.aumSection}>
                  <div className={CapitalStyles.aumAmount}>₦5b AUM</div>

                  <div className={CapitalStyles.statsGrid}>
                    <div className={CapitalStyles.statItem}>
                      <div className={CapitalStyles.statValue}>₦4bn</div>
                      <div className={CapitalStyles.statLabel}>Real Estate</div>
                    </div>
                    <div className={CapitalStyles.statItem}>
                      <div className={CapitalStyles.statValue}>₦500m</div>
                      <div className={CapitalStyles.statLabel}>Infrastructure</div>
                    </div>
                    <div className={CapitalStyles.statItem}>
                      <div className={CapitalStyles.statValue}>₦500m</div>
                      <div className={CapitalStyles.statLabel}>Private Equity</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={CapitalStyles.imageContent}>
                <img
                  src={Portfolio_img}
                  alt="Modern building architecture"
                  className={CapitalStyles.buildingImage}
                />
              </div>
            </div>
          </div>
        </section>

        <section className={CapitalStyles.partnership_section}>
          <div className={CapitalStyles.partnership_container}>
            <div className={CapitalStyles.partnership_heading}>
              <h2 className={CapitalStyles.partnership_section_title}>Our Journey with Limited Partners</h2>
              <h5 className={CapitalStyles.partnership_intro_heading}>Introducing Mosun Mall Dev LP</h5>
              <h5 className={CapitalStyles.partnership_heading_details}>Mosun Mall Dev LP (the "Deal" or "MMDLP") is our first single real estate deal targeting the retail sub-sector.</h5>
            </div>
            <div className={CapitalStyles.gray_section}>
              <div className={CapitalStyles.partnership_details}>
                <div>
                  <span style={{ color: "#E99B24", fontWeight: "bolder", fontSize: "1.5rem"}}>1</span>
                  <span>The investment strategy was to acquire land and develop a multi-purpose shopping mall in a prime location.</span>
                </div>
                <div>
                  <span style={{ color: "#8D3C25", fontWeight: "bolder", fontSize: "1.5rem"}}>2</span>
                  <span>The Manager aims to leverage its expected advantages and network to position the deal to develop a high rental grossing multi-purpose shopping mall and find suitable partners.</span>
                </div>
                <div>
                  <span style={{ color: "#361800", fontWeight: "bolder", fontSize: "1.5rem"}}>3</span>
                  <span>The Manager will seek investment opportunities where there is potential for enhancing ESG standards or (for new builds) implementing appropriate ESG standards throughout the investing period</span>
                </div>
              </div>
              <div className={CapitalStyles.partnership_image_container}>
                <img src={Partnership_image} alt="partnership visual" className={CapitalStyles.partnership_image} />
              </div>
            </div>
            <div className={CapitalStyles.partnership_section_2}>
              <h2 className={CapitalStyles.partnership_section2_heading}>How we structured the Deal</h2>
              <div className={CapitalStyles.partnership_section2_white}>
                <div className={CapitalStyles.section2_card_container}>
                  <div className={CapitalStyles.section2_card}>
                    <span>
                      <h5>Deal Manager</h5>
                      <h4>Mosun Capital</h4>
                    </span>
                    <span>
                      <h5>Target Return</h5>
                      <h4>The target return for the Deal is gross 80%</h4>
                    </span>
                    <span>
                      <h5>Target Stabilized Rental Yield</h5>
                      <h4>6%</h4>
                    </span>
                    <span>
                      <h5>Deal size</h5>
                      <h4>NGN 915 million</h4>
                    </span>
                  </div>
                  <div>
                    <div className={CapitalStyles.section2_text} style={{ color: "#8D3C25CC", fontSize: "20px", fontWeight: "bolder"}}>Investment Objective</div>
                    <div className={CapitalStyles.section2_text}>The Deal's strategy is to acquire land and develop a multi-purpose shopping mall in a prime location. The Deal will distribute yearly rental income generated from leasing spaces of the shopping mall.</div>
                  </div>
                  <div>
                    <div className={CapitalStyles.section2_text} style={{ color: "#8D3C25CC", fontSize: "20px", fontWeight: "bolder"}}>Term</div>
                    <div className={CapitalStyles.section2_text}>5 Years</div>
                  </div>
                  <div>
                    <div className={CapitalStyles.section2_text} style={{ color: "#8D3C25CC", fontSize: "20px", fontWeight: "bolder"}}>Management Fees</div>
                    <div className={CapitalStyles.section2_text}>The Manager will be entitled to receive a one-time management fee (the "Management Fee") equal to 1.5% of Total Commitments.
                      Management fee also includes 7-10% of gross rental income annually</div>
                  </div>
                  <div className={CapitalStyles.last_list}>
                    <div>
                      <div style={{ color: "#8D3C25CC", fontSize: "20px", fontWeight: "bolder" }}>Establishment Costs and Professional Fees</div>
                      <div className={CapitalStyles.reduced_width}>The Deal will bear all fees, costs and expenses incurred in connection with the establishment and launch of the Deal. The Deal will also retain the professional services of a Law firm and project manager</div>
                    </div>
                    <div>
                      <div style={{ color: "#8D3C25CC", fontSize: "20px", fontWeight: "bolder" }}>Status</div>
                      <div>Construction completed. Currently 100% leased</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={CapitalStyles.partnership_heading_2}>
                <h2 className={CapitalStyles.partnership_section_next}>What's Next</h2>
                <h5 className={CapitalStyles.partnership_intro_next}>Expanding Opportunities in Nigeria's Retail, Industrial, and Mixed-Use Real Estate</h5>
                <h5 className={CapitalStyles.partnership_heading_next}>Building on the success of our inaugural project,
                  Mosun Mall Dev LP, a prime retail development with
                  90% occupancy within 3 months of opening its doors
                  to business owners and the public, we are preparing
                  for our next phase of strategic deal origination and
                  structuring.
                </h5>
                <div className={CapitalStyles.what_section2_container}>
                  <div className={CapitalStyles.what_img_container}>
                    <img src={Next_image1} alt="next_img1" className={CapitalStyles.what_img} />
                  </div>
                  <div className={CapitalStyles.what_right_container}>
                    <img src={Next_image2} alt="next_img2" className={CapitalStyles.what_img2} />
                    <div className={CapitalStyles.what_right_text}>
                      <h6 className={CapitalStyles.what_text_heading}>Our Vision for the Future</h6>
                      <h6 className={CapitalStyles.what_text_details}>
                        Mosun Capital remains committed to unlocking
                        Nigeria's retail, industrial and mixed-use real estate potential through innovative deal structures that combine private equity and credit solutions. Our focus is on larger transactions exceeding NGN 5 billion
                        annually in the short to medium term, aligning with regulatory frameworks to structure private equity components up to that threshold.
                      </h6>
                    </div>
                  </div>
                </div>
                <div className={CapitalStyles.retail_container}>
                  <div className={CapitalStyles.retail_content1}>
                    <div className={CapitalStyles.content1_heading}>
                      Why Nigeria's Retail, Industrial
                      and Mixed-Use Sub-sectors?
                    </div>
                    <div className={CapitalStyles.content1_content}>
                      <div className={CapitalStyles.oppurtunity_heading}>Opportunities:</div>
                      <div className={CapitalStyles.oppurtunity_list}>
                        <span>
                          • Fragmented markets with significant consolidation
                          potential
                        </span>
                        <span>
                          • Growing demand driven by urbanisation, rising income
                          levels, and e-commerce expansion
                        </span>
                        <span>
                          • Supply chain modernisation and infrastructure investments
                          creating new logistics hubs
                        </span>
                        <span>
                          • Favourable government policies promoting private
                          sector-led growth
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className={CapitalStyles.retail_content2}>
                    <div className={CapitalStyles.retail_list_2}>
                      <h6 className={CapitalStyles.list2_heading1}>Long-term Outlook (10 Years):</h6>
                      <div className={CapitalStyles.retail_listContent1}>
                        <span>• Substantial upside from demographic trends and
                          infrastructure development
                        </span>
                        <span>• Increased last-mile logistics and distribution needs</span>
                        <span>• ESG standards are becoming a key driver for value and
                          investor interest</span>
                      </div>
                    </div>
                    <div className={CapitalStyles.risks_container}>
                      <h6 className={CapitalStyles.risks_heading1}>Challenges & Risks:</h6>
                      <div className={CapitalStyles.retail_listContent2}>
                        <span>• Economic volatility and currency fluctuations</span>
                        <span>• Regulatory changes and compliance requirements</span>
                        <span>• Infrastructure deficits in certain regions</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className={CapitalStyles.structure_container}>
          <div className={CapitalStyles.structure_centered}>
            <div className={CapitalStyles.structure_left_container}>
              <div className={CapitalStyles.structure_left_brown}>To inform our strategy, we partnered with a reputable real estate advisory firm, utilising comprehensive market data and analysis to identify lucrative opportunities while managing risks effectively.</div>
              <div className={CapitalStyles.structure_left_1}>
                <span className={CapitalStyles.left_1_heading}>Our Deal Structuring Approach</span>
                <span>Building on the success of Mosun Mall Dev LP, our approach emphasises strategic deal structuring that blends private equity with credit financing fostering partnerships with reputable stakeholders who share our vision of growth and value creation. Our disciplined investment process entails that we are also invested in our deals through our sister entities with an aim to optimise asset performance and ensure sustainable returns.</span>
              </div>
              <div className={CapitalStyles.structure_left_2}>
                <span className={CapitalStyles.left_2_heading}>Looking Ahead</span>
                <span>
                  As we prepare for our next deal, we invite current and prospective partners to stay engaged. We are actively working toward this goal and remain focused on structuring impactful, high-value transactions.
                  We believe Nigeria's retail, industrial and mixed-use real estate sub-sectors will continue to offer significant opportunities over the next decade, driven by demographic shifts, infrastructure upgrades, and evolving market needs.
                  We look forward to sharing more details as we move forward. Together, we can contribute to shape the future of Nigeria's real estate landscape.
                </span>
              </div>
            </div>
            <div className={CapitalStyles.structure_imgContainer}>
              <img src={Structure_img} alt="structuring approach" className={CapitalStyles.structure_image} />
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Capital;